/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ScriptSchemaFeature = {
  name: string
  /**
   * * `TEXT` - Text
   * * `NUMBER` - Number
   * * `BOOLEAN` - Boolean
   * * `DATE` - Date
   * * `LIST` - List
   * * `UNDEFINED` - Undefined
   */
  type?: ScriptSchemaFeature.type
  is_required?: boolean
  /**
   * The separator used if the feature name contains nested features
   */
  feature_nesting_separator?: string
}
export namespace ScriptSchemaFeature {
  /**
   * * `TEXT` - Text
   * * `NUMBER` - Number
   * * `BOOLEAN` - Boolean
   * * `DATE` - Date
   * * `LIST` - List
   * * `UNDEFINED` - Undefined
   */
  export enum type {
    TEXT = "TEXT",
    NUMBER = "NUMBER",
    BOOLEAN = "BOOLEAN",
    DATE = "DATE",
    LIST = "LIST",
    UNDEFINED = "UNDEFINED",
  }
}
